<template>
	<div class="head-main">
		<!-- 占位高度 -->
		<div class="zw-height"></div>
		<!-- pchead -->
		<div class="pc-head">
			<div class="head-top">
				<div class="warper clearfix">
					<div class="top-right fr acea-row row-middle">
						<!-- <div class="right-input acea-row row-middle">
							<input type="text" placeholder="搜索" />
							<a class="search-btn">
								<i class="iconfont icon-sousuo"></i>
							</a>
						</div> -->
						<div class="right-language">
							<img src="@/assets/image/guoqi1.png" alt="" class="img" />
							<div class="img-list">
								<a
									class="acea-row row-middle"
									:class="{ active: item.lang == 'zh-cn' }"
									v-for="(item, i) in languageList"
									:key="i"
									:href="item.url"
									><img :src="item.img" alt="" />
									<span>{{ item.language }}</span>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="head-nav">
				<div class="warper">
					<div class="nav-left">
						<router-link to="/">
							<img src="@/assets/image/logo.png" alt="" />
						</router-link>
					</div>
					<div class="nav-right">
						<!--路由导航-->
						<ul>
							<li
								class="nav-item"
								v-for="(item, i) in navList"
								:key="i"
								:class="{
									'has-child': item.son,
									active: item.id == headId,
								}"
								@mouseenter.stop="hover(item.id)"
								@mouseleave.stop="leave()"
							>
								<h3>
									<router-link
										:to="{ name: item.link, params: { headId: item.id } }"
										>{{ item.title }}</router-link
									>
									<i class="iconfont icon-arrow-bot" v-if="item.son"></i>
								</h3>
								<div class="child-list" v-if="item.son && hoverId == item.id">
									<router-link
										:to="{ name: child.link, params: { headId: child.pid } }"
										v-for="(child, k) in item.child"
										:key="k"
										:class="path == child.link ? 'active' : ''"
										>{{ child.title }}</router-link
									>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
		<!-- 移动端head -->
		<div class="phone-head" :class="{ in: isOpen }">
			<div class="head-top acea-row row-between-wrapper">
				<router-link to="/" class="logo">
					<img src="@/assets/image/logo.png" alt="" />
				</router-link>
				<!-- <div class="search-input acea-row row-middle">
					<input type="text" placeholder="搜索" />
					<a class="search-btn">
						<i class="iconfont icon-sousuo"></i>
					</a>
				</div> -->
				<a class="toggle-btn" @click="isOpen = true">
					<img src="@/assets/image/menu-btn.png" alt="" />
				</a>
			</div>
			<div class="bgDiv"></div>
			<div class="head-nav">
				<!-- 关闭 -->
				<div class="close-btn" @click="isOpen = false">
					<a><i class="iconfont icon-guanbi"></i></a>
				</div>

				<ul class="men-one-ul">
					<li
						v-for="(item, i) in navList"
						class="one-li"
						:key="i"
						:class="{ active: item.id == headId, open: i == headIndex }"
						@click="showToggle(i)"
					>
						<h3 v-if="item.son">
							<a>{{ item.title }}</a>
							<i class="iconfont icon-jiahao"></i>
						</h3>
						<h3 v-else>
							<router-link
								:to="{ name: item.link, params: { headId: item.id } }"
								>{{ item.title }}</router-link
							>
						</h3>
						<div class="child-list" v-if="item.son">
							<router-link
								:to="{ name: child.link, params: { headId: child.pid } }"
								v-for="(child, k) in item.child"
								:key="k"
								:class="path == child.link ? 'active' : ''"
								>{{ child.title }}</router-link
							>
						</div>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
	import { getNavList, getLanguageList } from "../../api";
	export default {
		data() {
			return {
				imgUrl: this.$store.state.imgUrl,
				language: this.$store.state.language,
				hoverId: 0,
				toggleShow: true,
				headId: 1,
				navList: [],
				path: null,
				isOpen: false,
				webInfo: {},
				headIndex: null,
				languageList: [],
			};
		},
		mounted: function() {
			let that = this;
			this.headId = this.$route.params.headId || 1;
			this.path = this.$route.name;
			getLanguageList().then((res) => {
				that.languageList = res.data.result;
			});
			getNavList().then((res) => {
				that.navList = res.data.result;
			});
		},
		// 监听,当路由发生变化的时候执行
		watch: {
			$route(to, from) {
				this.headId = this.$route.params.headId || 1;
				this.path = this.$route.name;
				this.isOpen = false;
			},
		},
		methods: {
			openSlide() {
				this.isOpen = !this.isOpen;
			},
			hover(e) {
				this.hoverId = e;
			},
			leave() {
				this.hoverId = 0;
			},
			showToggle(e) {
				if (this.headIndex == e) {
					this.headIndex = null;
				} else {
					this.headIndex = e;
				}
			},
		},
	};
</script>

<style lang="less" scoped>
	.zw-height {
		height: 170px;
	}
	.pc-head {
		position: fixed;
		background: #fff;
		left: 0;
		right: 0;
		z-index: 99;
		box-shadow: 0px 4px 4px 0px rgba(0, 10, 40, 0.1);
		top: 0;
		.head-top {
			color: #999999;
			padding: 10px 0;
			border-bottom: 2px solid #00598a;
			.top-right {
				.right-input {
					input {
						height: 40px;
						line-height: 40px;
						border: 1px solid #eaeaea;
						width: 240px;
						padding: 0 10px;
						box-sizing: border-box;
					}
					.search-btn {
						width: 40px;
						height: 40px;
						text-align: center;
						line-height: 40px;
						color: #fff;
						display: block;
						background: #00598a;
						.iconfont {
							font-size: 20px;
						}
					}
					.search-btn:hover {
						opacity: 0.8;
					}
				}

				.right-language {
					position: relative;
					height: 40px;
					.img {
						margin-left: 40px;
						width: 48px;
						height: 32px;
						cursor: pointer;
						padding: 4px 0;
					}
					.img-list {
						position: absolute;
						z-index: 99;
						background: #ffffff;
						padding: 10px;
						width: 240px;
						right: 0;
						top: 40px;
						box-shadow: 0px 4px 4px 0px rgba(0, 10, 40, 0.2);
						display: none;
						a {
							padding: 10px;
							img {
								width: 48px;
								height: 32px;
							}
							span {
								display: block;
								margin-left: 10px;
							}
						}
						a:hover {
							background: #e5eef3;
							color: #00598a;
						}
						a.active {
							background: #e5eef3;
							color: #00598a;
						}
					}
				}
				.right-language:hover .img-list {
					display: block;
				}
			}
		}
		.head-nav {
			.warper {
				position: relative;
			}
			.nav-left {
				position: absolute;
				bottom: 0;
				left: 0;
				img {
					height: 78px;
					width: auto;
				}
			}
			.nav-right {
				text-align: right;
				padding: 24px 0;
			}
			.nav-item {
				display: inline-block;
				margin-left: 40px;
				position: relative;
				h3 {
					position: relative;
					cursor: pointer;
					font-size: 16px;
					a {
						line-height: 60px;
						display: block;
					}
				}
				h3:before {
					position: absolute;
					bottom: -5px;
					left: 0;
					width: 100%;
					height: 2px;
					background: rgba(0, 0, 0, 0.1);
					content: "";
					opacity: 0;
					-ms-transition: opacity 0.3s, -webkit-transform 0.3s;
					-webkit-transition: opacity 0.3s, -webkit-transform 0.3s;
					transition: opacity 0.3s, transform 0.3s;
					-ms-transform: translateY(10px);
					-webkit-transform: translateY(10px);
					transform: translateY(10px);
				}
				.iconfont {
					right: 0;
					top: 0;
					position: absolute;
					-webkit-transition-duration: 0.3s;
					transition-duration: 0.3s;
					-webkit-transition-timing-function: ease-out;
					transition-timing-function: ease-out;
				}
				.child-list {
					line-height: 1;
					position: absolute;
					top: 60px;
					width: 260px;
					background: #fff;
					padding: 10px;
					z-index: 99;
					box-shadow: 0px 4px 4px 0px rgba(0, 10, 40, 0.2);
					display: none;
					a {
						display: block;
						color: #333333;
						text-align: left;
						padding: 0 10px;
						height: 40px;
						line-height: 40px;
					}
					a.active {
						color: #00598a;
						font-weight: bold;
						background: #e5eef3;
					}
					a:hover {
						color: #00598a;
						font-weight: bold;
						background: #e5eef3;
					}
				}
			}
			.nav-item.active {
				h3 {
					a {
						color: #00598a;
					}
				}
				h3:before {
					bottom: 8px;
					height: 2 px;
					background: #00598a;
					opacity: 1;
					-ms-transform: translateY(0);
					-webkit-transform: translateY(0);
					transform: translateY(0);
				}
			}
			.nav-item:hover .child-list {
				display: block;
			}
			.nav-item:hover h3:before {
				bottom: 8px;
				height: 2 px;
				background: #00598a;
				opacity: 1;
				-ms-transform: translateY(0);
				-webkit-transform: translateY(0);
				transform: translateY(0);
			}

			.nav-item:first-child {
				margin-left: 0;
			}
			.last-item {
				margin-left: 100px;
				.current {
					font-weight: bold;
					font-size: 16px;
				}
			}
		}
	}
	.phone-head {
		display: none;
		background: #ffffff;
		box-shadow: 0px 4px 8px 0px rgba(0, 10, 40, 0.1);
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		z-index: 99;
		.head-top {
			height: 88px;
			line-height: 88px;
			padding: 0 30px;
			display: flex;
			justify-content: space-between;
			position: relative;
			a {
				color: #fff;
			}
			.top-right {
				color: #fff;
				letter-spacing: 2px;
				font-size: 20px;
				.current {
					font-weight: bold;
					font-size: 24px;
				}
			}
			.logo {
				display: block;
				width: 150px;
				bottom: 0;
				left: 0;
				img {
					max-width: 100%;
					height: auto;
					position: absolute;
					left: 30px;
					bottom: 0;
				}
			}
			.toggle-btn {
				width: 44px;
				img {
					max-width: 100%;
				}
			}
			.search-input {
				flex: 1;
				margin: 0 40px 0 190px;
				input {
					height: 64px;
					line-height: 64px;
					border: 1px solid #eaeaea;
					padding: 0 10px;
					box-sizing: border-box;
					flex: 1;
					font-size: 24px;
				}
				.search-btn {
					width: 64px;
					height: 64px;
					text-align: center;
					color: #fff;
					display: block;
					background: #00598a;
					display: flex;
					align-items: center;
					justify-content: center;
					.iconfont {
						font-size: 30px;
					}
				}
				.search-btn:hover {
					opacity: 0.8;
				}
			}
		}
		.head-nav {
			width: 80%;
			height: 100%;
			background-color: #fff;
			position: fixed;
			right: -100%;
			top: 0;
			bottom: 0;
			z-index: 100;
			padding-top: 0;
			transition: all 0.5s;
			-moz-transition: all 0.3s;
			-webkit-transition: all 0.3s;
			-o-transition: all 0.3s;
			-ms-transition: all 0.3s;
			a {
				color: #333;
				display: block;
			}
			.close-btn {
				padding: 20px 20px 40px;
				text-align: right;
				a {
					display: inline-block;
					width: 58px;
					height: 58px;
					background: #00598a;
					color: #fff;
					text-align: center;
					line-height: 58px;
					.iconfont {
						font-size: 30px;
					}
				}
			}
			.men-one-ul {
				.one-li {
					line-height: 1;
					padding: 30px 40px;
					border-bottom: 1px solid #eaeaea;
					h3 {
						position: relative;
						font-size: 22px;
						font-weight: normal;
					}
					.iconfont {
						right: 0;
						top: -2px;
						position: absolute;
						color: #999;
						font-size: 30px;
						-webkit-transition-duration: 0.3s;
						transition-duration: 0.3s;
						-webkit-transition-timing-function: ease-out;
						transition-timing-function: ease-out;
					}
				}
				.one-li.active h3 {
					font-weight: bold;
				}

				.child-list {
					display: none;
					font-size: 18px;
					margin-left: 40px;
					margin-top: 40px;
					a {
						margin-top: 30px;
					}
					a.active {
						color: #00598a;
					}
					a:first-child {
						margin-top: 0;
					}
				}
				.one-li.open {
					.iconfont {
						transform: rotate(-45deg);
					}
					.child-list {
						display: block;
					}
				}
			}
		}
		.bgDiv {
			width: 100%;
			height: 100%;
			background-color: rgba(0, 0, 0, 0.6);
			position: fixed;
			z-index: 99;
			bottom: 0;
			right: -100%;
			top: 0;
			transition: all 0.5s;
			-moz-transition: all 0.3s;
			-webkit-transition: all 0.3s;
			-o-transition: all 0.3s;
			-ms-transition: all 0.3s;
		}
	}
	.phone-head.in {
		.head-nav,
		.bgDiv {
			right: 0;
		}
	}

	@media screen and (max-width: 1200px) {
		.zw-height {
			height: 88px;
		}
		.phone-head {
			display: block;
		}
		.pc-head {
			display: none;
		}
	}

	@media screen and (max-width: 768px) {
		.zw-height {
			height: 78px;
		}
		.phone-head {
			.head-top {
				height: 78px;
				line-height: 78px;
				.logo {
					width: 120px;
					img {
						max-height: 60px;
					}
				}
				.toggle-btn {
					width: 38px;
				}
				.search-input {
					margin: 0 40px 0 160px;
					input {
						height: 54px;
						line-height: 54px;
						font-size: 20px;
					}
					.search-btn {
						width: 54px;
						height: 54px;
						.iconfont {
							font-size: 26px;
						}
					}
				}
			}
			.head-nav {
				.close-btn {
					padding: 20px 20px 20px;
					a {
						width: 48px;
						height: 48px;
						line-height: 48px;
						.iconfont {
							font-size: 26px;
						}
					}
				}
			}
		}
	}

	@media screen and (max-width: 640px) {
		.zw-height {
			height: 50px;
		}
		.phone-head {
			.head-top {
				height: 50px;
				line-height: 50px;
				padding: 0 10px;
				.logo {
					width: 70px;
					img {
						max-height: 35px;
						left: 20px;
					}
				}
				.toggle-btn {
					width: 18px;
				}
				.search-input {
					margin: 0 10px 0 90px;
					input {
						height: 32px;
						line-height: 32px;
						font-size: 14px;
					}
					.search-btn {
						width: 32px;
						height: 32px;
						.iconfont {
							font-size: 16px;
						}
					}
				}
			}
			.head-nav {
				.men-one-ul {
					.one-li {
						padding: 20px;
						h3 {
							font-size: 16px;
						}
						.iconfont {
							font-size: 20px;
						}
					}
					.child-list {
						margin-top: 20px;
						margin-left: 20px;
						font-size: 14px;
						a {
							margin-top: 20px;
						}
					}
				}
				.close-btn {
					padding: 10px;
					a {
						width: 30px;
						height: 30px;
						line-height: 30px;
						.iconfont {
							font-size: 16px;
						}
					}
				}
			}
		}
	}
</style>
